function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Path>",
  d: "M28.3 14.46v-3.25H16.56l-.41-3.33-6.2.12-3.1 3-6.17.44-.26 3h.11c-.47 0-.5.25-.5.57v.52c0 .32 0 .53.5.53h.6l.19.11a2.38 2.38 0 104.71.47h14.1a2.38 2.38 0 104.76 0v-.06l1.19-.14 2.31-.67a1.15 1.15 0 00.53-.78.56.56 0 00-.62-.53z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Compound Path>",
  d: "M27.6 0h-9.83v9.83h9.83V0zm-3.53 7.68l-1.49-1.49-1.48 1.48-1.17-1.17 1.48-1.48-1.49-1.49 1.13-1.13 1.49 1.49 1.48-1.48 1.13 1.2-1.48 1.48 1.49 1.49z"
}));

var SvgMaximumpayload = function SvgMaximumpayload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 28.87 19.05"
  }, props), _ref);
};

export default SvgMaximumpayload;